import Applications from './component/Applications/index'
import { Routes, Route } from 'react-router-dom'
import ApplicationsForm from './component/Applications/ApplicationsForm/ApplicationsForm'
import SuccessApplications from './component/Applications/SuccessApplications'
import TUBITAKDergiForm from './component/Applications/TUBITAKDergiForm'
import TesislerBasvuruForm from './component/Applications/TesislerBasvuruForm'
import TesislerList from './component/Applications/TesislerBasvuruForm/TesislerList'
import ESporBasvuruForm from './component/Applications/ESporBasvuruForm'
import TheatreTicketForm from './component/Applications/TheatreTicketForm'
import HistoryPage from './component/Applications/TheatreTicketForm/HistoryPage'
import TicketBuyPage from './component/Applications/TheatreTicketForm/TicketBuyPage'
import TheatreSuccess from './component/Applications/TheatreTicketForm/TheatreSuccess'
import HobiBahceleriHome from './component/Applications/HobiBahceleriForm'
import HobiBahcesiKosullar from './component/Applications/HobiBahceleriForm/HobiBahcesiKosullar'
import HobiBahceleriForm from './component/Applications/HobiBahceleriForm/HobiBahceleriForm'
import HobiBahceleriOdeme from './component/Applications/HobiBahceleriForm/HobiBahceleriOdeme'
import HobiSuccessPage from './component/Applications/HobiBahceleriForm/HobiSuccessPage'
import HobiBasvuruList from './component/Applications/HobiBahceleriForm/HobiBasvuruList'
import { useLocation } from 'react-router-dom'
import EvlilikGelismeForm from './component/Applications/EvlilikGelismeForm/EvlilikGelismeForm'
import BisikletYarisiForm from './component/Applications/BisikletYarisiForm/BisikletYarisiForm'
import AtletizmYarisiForm from './component/Applications/AtletizmYarisiForm/AtletizmYarisiForm'
import TabiatBasvuruForm from './component/Applications/TabiatBasvuruForm/TabiatBasvuruForm'

const App = () => {
  let location = useLocation()
  const token = location.search.slice(7)
  
  if (token) {
    localStorage.setItem('token', JSON.stringify(token))
  }
  
  return (
    <>
      <Routes>
        <Route path='/' index element={<Applications />} />
        <Route path='/basvur' element={<ApplicationsForm />} />
        <Route path='/evlilik' element={<EvlilikGelismeForm />} />
        <Route path='/bisiklet-yarisi' element={<BisikletYarisiForm />} />
        <Route path='/atletizm-yarisi' element={<AtletizmYarisiForm />} />
        <Route path='/tabiat-basvuru' element={<TabiatBasvuruForm />} />
        <Route path='/tubitak-form' element={<TUBITAKDergiForm />} />
        <Route path='/tesisler-form' element={<TesislerBasvuruForm />} />
        <Route path='/e-spor-form' element={<ESporBasvuruForm />} />
        <Route path='/tesisler-list' element={<TesislerList />} />
        <Route path='/theatre-ticket' element={<TheatreTicketForm />} />
        <Route path='/history-page' element={<HistoryPage />} />
        <Route path='/ticket-buy-page' element={<TicketBuyPage />} />
        <Route path='/ticket-buy-success' element={<TheatreSuccess />} />
        <Route path='/success-applications' element={<SuccessApplications />} />
        <Route path='/hobiHome' element={<HobiBahceleriHome />} />
        <Route path='/hobiKosullar' element={<HobiBahcesiKosullar />} />
        <Route path='/hobiForm' element={<HobiBahceleriForm />} />
        <Route path='/hobiOdeme' element={<HobiBahceleriOdeme />} />
        <Route path='/hobiSuccess' element={<HobiSuccessPage />} />
        <Route path='/hobiList' element={<HobiBasvuruList />} />
      </Routes>
    </>
  )
}

export default App
